export const SYNC_WISHLISTED_PRODUCTS = 'SYNC_WISHLISTED_PRODUCTS'
export const DELETE_WISHLISTED_PRODUCT = 'DELETE_WISHLISTED_PRODUCT'
export const WISHLIST_LOADING = 'WISHLIST_LOADING'
